module.exports = __webpack_public_path__ + "img/app-store.e1562a85.png";